import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { SessionHandler } from '../../../../shared/services/session-handler.service';
import { Config } from './type';
import { NavigationEnd, Router } from '@angular/router';
import { APPCONFIG } from '../../../../config';
import { CommonService } from '../../../../shared/services/common.service';
@Component({
  selector: 'accordion',
  template: require('./accordion.component.html'),
  styles: [require('./accordion.component.scss')]
})
export class AccordionComponent implements OnInit {
  AppConfig;
  @Input() options;
  config: Config;

  allAccess = false;
  isIcb = false;
  isFOC = false;
  isHome = true;

  roles: string[] = [];
  hasFOCRole = false;
  hasOnlyFOCRole = false;

  /* ------------------- MENU DEFINITIONS -------------------- */

  accordianWRTMenu: any[] = [
    {
      name: 'Web Return Tool',
      iconClass: '',
      active: false,
      menuIconName: 'construction',
      id: 'w_r_t',
      submenu: [
        { name: 'Internet Call Booking', url: '#/app/icb/dashboard', submenuIconName: 'call' },
        { name: 'Free of Charge', url: '#/app/foc_dashboard', submenuIconName: 'call' }
      ]
    }
  ];

  accordianICBMenu: any[] = [
    {
      name: 'Internet Call Booking',
      iconClass: '',
      active: false,
      menuIconName: 'call',
      id: 'i_c_b',
      submenu: [
        { name: 'Web Return Tool', url: '#/app/dashboard', submenuIconName: 'construction' },
        { name: 'Free of Charge', url: '#/app/foc_dashboard', submenuIconName: 'call' }
      ]
    }
  ];

  accordianFOCMenu: any[] = [
    {
      name: 'Free of Charge',
      iconClass: '',
      active: false,
      menuIconName: 'call',
      id: 'f_o_c',
      submenu: [
        { name: 'Web Return Tool', url: '#/app/dashboard', submenuIconName: 'construction' },
        { name: 'Internet Call Booking', url: '#/app/icb/dashboard', submenuIconName: 'call' }
      ]
    }
  ];

  accordianHomeMenu: any[] = [
    {
      name: 'Home',
      iconClass: '',
      active: false,
      menuIconName: 'home',
      id: 'home',
      submenu: [
        { name: 'Internet Call Booking', url: '#/app/icb/dashboard', submenuIconName: 'call' },
        { name: 'Web Return Tool', url: '#/app/dashboard', submenuIconName: 'construction' },
        { name: 'Free of Charge', url: '#/app/foc_dashboard', submenuIconName: 'call' }
      ]
    }
  ];

  /* --------------------------------------------------------- */

  constructor(
    private router: Router,
    public sessionHandler: SessionHandler,
    private ref: ChangeDetectorRef,
    private commonService : CommonService
  ) {
    this.AppConfig = APPCONFIG;
  
    // ---------- USER ROLES ----------
    const loginDataStr = this.sessionHandler.getItem('loginData');
    this.roles = loginDataStr ? JSON.parse(loginDataStr).role || [] : [];
  
    // Only roles that explicitly contain "FOC" are FOC roles
    this.hasFOCRole = this.roles.some(r => r.includes('FOC'));

    this.hasOnlyFOCRole = this.commonService.isOnlyFOCRole(this.roles);
    console.log("hasonlyfocrole from according : "+this.hasOnlyFOCRole);
  
    // allAccess flag
    this.allAccess = JSON.parse(this.sessionHandler.getItem('allAccess'));
  
    // // ---------- SYNC CONTEXT FROM URL (CRITICAL FIX) ----------
    // const currentUrl = this.router.url || window.location.hash.replace('#', '');
  
    // if (currentUrl.startsWith('/app/icb')) {
    //   this.sessionHandler.saveItem('isIcb', 'true');
    //   this.sessionHandler.saveItem('isFOC', 'false');
    //   this.sessionHandler.saveItem('isHome', 'false');
    // }
    // else if (currentUrl.startsWith('/app/foc') && this.hasFOCRole) {
    //   this.sessionHandler.saveItem('isIcb', 'false');
    //   this.sessionHandler.saveItem('isFOC', 'true');
    //   this.sessionHandler.saveItem('isHome', 'false');
    // }
    // else if (currentUrl.startsWith('/app/dashboard')) {
    //   this.sessionHandler.saveItem('isIcb', 'false');
    //   this.sessionHandler.saveItem('isFOC', 'false');
    //   this.sessionHandler.saveItem('isHome', 'false');
    // }
    // else {
    //   // fallback = HOME
    //   this.sessionHandler.saveItem('isIcb', 'false');
    //   this.sessionHandler.saveItem('isFOC', 'false');
    //   this.sessionHandler.saveItem('isHome', 'true');
    // }
  
    // ---------- READ FINAL FLAGS ----------
    this.isIcb = JSON.parse(this.sessionHandler.getItem('isIcb'));
    this.isHome = JSON.parse(this.sessionHandler.getItem('isHome'));
  
    const savedFOCFlag = JSON.parse(this.sessionHandler.getItem('isFOC'));
    this.isFOC = this.hasFOCRole ? savedFOCFlag : false;
  
    // ---------- EXISTING LOGIC ----------
    this.manuManagement();
    this.detectStorageChnges();
  
    // Remove FOC menu if user is NOT a FOC role holder
    if (!this.hasFOCRole) {
      this.stripFOCEntries();
    }
  }
  

  ngOnInit() {
    this.config = this.mergeConfig(this.options);
  
    this.syncContextFromUrl(this.router.url);
  
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.syncContextFromUrl(e.urlAfterRedirects);
      }
    });
  }
  

  mergeConfig(options: Config) {
    return { multi: true, ...(options || {}) };
  }

  /* ------------------ MENU TOGGLES ------------------ */

  toggleWRT(i: number) {
    if (!this.config.multi) {
      this.accordianWRTMenu.forEach((m, idx) => idx !== i && (m.active = false));
    }
    this.accordianWRTMenu[i].active = !this.accordianWRTMenu[i].active;
  }

  toggleICB(i: number) {
    if (!this.config.multi) {
      this.accordianICBMenu.forEach((m, idx) => idx !== i && (m.active = false));
    }
    this.accordianICBMenu[i].active = !this.accordianICBMenu[i].active;
  }

  toggleFOC(i: number) {
    if (!this.config.multi) {
      this.accordianFOCMenu.forEach((m, idx) => idx !== i && (m.active = false));
    }
    this.accordianFOCMenu[i].active = !this.accordianFOCMenu[i].active;
  }

  toggleHome(i: number) {
    if (!this.config.multi) {
      this.accordianHomeMenu.forEach((m, idx) => idx !== i && (m.active = false));
    }
    this.accordianHomeMenu[i].active = !this.accordianHomeMenu[i].active;
  }

  /* ------------------ CONTEXT MANAGEMENT ------------------ */

  manuManagement() {
    this.sessionHandler.watchStorage().subscribe(() => {
      setTimeout(() => {
        this.isIcb = JSON.parse(this.sessionHandler.getItem('isIcb'));
      });

      setTimeout(() => {
        const focFlag = JSON.parse(this.sessionHandler.getItem('isFOC'));
        this.isFOC = this.hasFOCRole ? focFlag : false;
      });
    });
  }

  detectStorageChnges() {
    this.sessionHandler.watchStorage().subscribe(() => {
      this.isHome = JSON.parse(this.sessionHandler.getItem('isHome'));
    });
  }

  toggleCollapsedNav() {
    this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
  }

  /* ------------------ NAVIGATION / CLICK ------------------ */

  handleSubmenuClick(submenu: any) {
    this.toggleCollapsedNav();
    // this.updateContext(submenu.url);
  }

  // updateContext(url: string) {
  //   const u = url.replace('#', '');

  //   if (u.startsWith('/app/dashboard')) {
  //     this.sessionHandler.saveItem('isIcb', 'false');
  //     this.sessionHandler.saveItem('isFOC', 'false');
  //     this.sessionHandler.saveItem('isHome', 'false');
  //   }

  //   else if (u.startsWith('/app/icb/dashboard')) {
  //     this.sessionHandler.saveItem('isIcb', 'true');
  //     this.sessionHandler.saveItem('isFOC', 'false');
  //     this.sessionHandler.saveItem('isHome', 'false');
  //   }

  //   else if (u.startsWith('/app/foc_dashboard') && this.hasFOCRole) {
  //     this.sessionHandler.saveItem('isIcb', 'false');
  //     this.sessionHandler.saveItem('isFOC', 'true');
  //     this.sessionHandler.saveItem('isHome', 'false');
  //   }
  // }

  /* ------------------ REMOVE FOC LINKS IF USER IS NOT FOC ------------------ */

  stripFOCEntries() {
    const removeFOC = (submenu: any[]) => {
      if (!submenu) return;
  
      for (let i = submenu.length - 1; i >= 0; i--) {
        const url = submenu[i] && submenu[i].url ? submenu[i].url : '';
  
        if (url.indexOf('foc_dashboard') !== -1 || url.indexOf('/app/foc') !== -1) {
          submenu.splice(i, 1);
        }
      }
    };
  
    removeFOC(this.accordianWRTMenu[0].submenu);
    removeFOC(this.accordianICBMenu[0].submenu);
    removeFOC(this.accordianHomeMenu[0].submenu);
  }
  
  allowSubmenu(submenu: any): boolean {
    if (this.hasFOCRole) return true;
  
    if (!submenu || !submenu.url) return true;
  
    const url = submenu.url;
  
    if (url.includes('foc_dashboard') || url.includes('/app/foc')) {
      return false;
    }
  
    return true;
  }

  syncContextFromUrl(url: string) {
    if (url.startsWith('/app/icb')) {
      this.sessionHandler.saveItem('isIcb', true);
      this.sessionHandler.saveItem('isFOC', false);
      this.sessionHandler.saveItem('isHome', false);
    }
    else if (url.startsWith('/app/foc') && this.hasFOCRole) {
      this.sessionHandler.saveItem('isIcb', false);
      this.sessionHandler.saveItem('isFOC', true);
      this.sessionHandler.saveItem('isHome', false);
    }
    else if (url.startsWith('/app/dashboard')) {
      this.sessionHandler.saveItem('isIcb', false);
      this.sessionHandler.saveItem('isFOC', false);
      this.sessionHandler.saveItem('isHome', false);
    }
  }
  
  navigate(url: string) {
    const cleanUrl = url.replace('#', '');
    this.router.navigateByUrl(cleanUrl);
  }
  
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/accordion/accordion.component.ts